// The Vue build version to load with the `import` command

// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// async，decorator，es6已经默认提供，给老IE polyfill一下promise
import 'es6-promise/auto';
// import './scripts/placeholders'
import * as elTablRewrite from './scripts/elTabsRewrite';
import Vue from 'vue';
import './styles/_normalize.scss';
import {
  Dialog,
  MessageBox,
  Icon,
  Row,
  Col,
  Upload,
  Form,
  FormItem,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxGroup,
  Select,
  Option,
  Menu,
  Submenu,
  MenuItem,
  Step,
  Steps,
  MenuItemGroup,
  // OptionGroup,
  Button,
  Table,
  TableColumn,
  Pagination,
  Carousel,
  Message,
  CarouselItem,
  Cascader,
  Tabs,
  TabPane,
  Progress,
  DatePicker
} from 'element-ui';
import { sync } from 'vuex-router-sync';
import 'element-ui/lib/theme-default/index.css';
import store from './vuex/store';
import router from './router';
import * as filters from './filters';
import App from './App.vue';

// todo: 可以考虑引入postcss-bem
sync(store, router);
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// decrease package size. Necessary components only.
Vue.use(Dialog);
// Vue.use(MessageBox)
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Select);
Vue.use(Option);
// Vue.use(OptionGroup)
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Cascader);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Progress);
Vue.use(DatePicker);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Step);
Vue.use(Steps);

Vue.config.productionTip = false;

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;

Tabs.components.TabNav.components.TabBar.computed.barStyle = elTablRewrite.SetBarStyle;

  /* eslint-disable no-new */
new Vue({
  // el: '#app',
  router,
  store,
  // template: '<App/>',
  // components: {App}
  render: h => h(App)
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js